/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { IPatientCategory } from 'app/shared/model/patient-category.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IHospitalPatientAttribute {
  id?: string;
  uhid?: string | null;
  active?: boolean | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  hospital?: IHospital | null;
  patientCategory?: IPatientCategory | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<IHospitalPatientAttribute> = {
  active: false,
};
